<template lang="pug">
    div#errorPage
        Header
        div.page404
            div.content
                h1.code 404
                div.text Это значит, что этой страницы не существует.
                router-link(to="/").btn.btn-white Вернуться на главную
</template>

<script>
    import Header from '@/components/Header.vue'
    export default {
        name: "404",
        components: {
            Header
        }
    }
</script>

<style scoped lang="scss">
    #errorPage {
        min-height: 100%;
        max-height: 100%;
        height: calc(100vh - 174px);
        display: block;
    }
    .page404 {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100%;
        background-color: #ffffff;
        overflow: hidden;
        z-index: 99;

        @keyframes rotate {
            0% {
                transform: translate(-50%, 0) rotateZ(0deg);
            }
            50% {
                transform: translate(-50%, -2%) rotateZ(180deg);
            }
            100% {
                transform: translate(-50%, 0%) rotateZ(360deg);
            }
        }

        .content {
            position: relative;
            max-width: 600px;
            width: 100%;
            padding: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 99;

            &:before,
            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                margin: auto;
                min-width: 650px;
                min-height: 650px;
                background-color: rgba(0, 39, 255, .7);
                animation-name: rotate;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
                z-index: -1;
            }

            &:before {
                bottom: 16vh;
                border-radius: 47%;
                animation-duration: 10s;
            }
            &:after {
                bottom: 12vh;
                opacity: .5;
                border-radius: 50%;
                animation-duration: 10s;
            }

            .code {
                font-size: calc(200px - 5vh);
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                margin: 0 0 30px;
                display: block;
            }
            .text {
                font-size: 15px;
                font-weight: 500;
                line-height: 19px;
                color: #ffffff;
                text-align: center;
                margin: 0 0 50px;
                display: block;
            }
            .btn {
                color: #3150ff;
                cursor: pointer;
                &:hover {
                    transform: translateY(-7px);
                }
            }
        }
    }
</style>
